import { cardTitle } from '../../assets/jss/wisene-material-dashboard-pro-react-types';
import { connect } from 'react-redux';
import { setSystemNotifications } from '../../stores/actions/dashboardActions';
import Button from '../../../components/CustomButtons/ButtonTS';
import Card from '../../../components/Card/CardTS';
import CardHeader from '../../../components/Card/CardHeader';
import CardBody from '../../../components/Card/CardBody';
import CardIcon from '../../../components/Card/CardIcon.js';
import dashboardStyle from '../../assets/jss/views/dashboardStyleTS';
import Loading from '../../components/Loading/Loading';
import ErrorComponent from '../ErrorComponent/ErrorComponent';
import GridContainer from '../../../components/Grid/GridContainer';
import GridItem from '../../../components/Grid/GridItem';
import styles from '../../assets/jss/views/dashboardStyle';
import Notifications from '@material-ui/icons/Notifications'; 
import FormControl from "@material-ui/core/FormControl";
import Checkbox from "@material-ui/core/Checkbox";
import InputLabel from "@material-ui/core/InputLabel";
import Switch from '@material-ui/core/Switch';
import React, { useState, useEffect } from 'react';


const style = {
    cardTitle,
    cardCategory: styles.cardCategory,
};

interface ISystemNotificationsCardProps {
    hideAlert: () => void;
    mobileView: boolean;
    accountCategory: string;
    systemID: number;
    systemVersion: string;
    updatedViaWebsiteAt: any;
    notificationsEmailOn: boolean;
    notificationsPushOn: boolean;
    notificationsSmsOn: boolean;
    settingNotificationsSuccess: boolean;
    settingNotificationsFailed: boolean;
    setSystemNotifications: (systemID: number, notificationsEmailOn: boolean, notificationsPushOn: boolean, notificationsSmsOn: boolean, updatedViaWebsiteAt: any) => void;
}

const SystemNotificationsCard  = (props: ISystemNotificationsCardProps) => {
    const {hideAlert, systemID, setSystemNotifications, updatedViaWebsiteAt,
        notificationsEmailOn, notificationsPushOn, notificationsSmsOn, systemVersion,
        settingNotificationsSuccess, settingNotificationsFailed, accountCategory} = props;
    const [emailOn, setEmailOn] = useState(notificationsEmailOn);
    const [pushOn, setPushOn] = useState(notificationsPushOn);
    const [smsOn, setSmsOn] = useState(notificationsSmsOn);
    const [submitted, setSubmitted] = useState(false);

    useEffect(() => {
        if (settingNotificationsSuccess) {
            hideAlert();
        }
    }, [settingNotificationsSuccess]);

    const onSubmit = () => {
        setSubmitted(true);
        setSystemNotifications(systemID, (systemVersion != 'W2' ? emailOn : notificationsEmailOn), pushOn, (accountCategory == 'wisene' && systemVersion != 'W2' ? smsOn : notificationsSmsOn), updatedViaWebsiteAt);
    };

    const button = () => {
        if (submitted && !settingNotificationsSuccess && !settingNotificationsFailed) {
            return (
                <div style={{ width: '100%', marginTop: '25px', marginBottom: '10px', paddingLeft: '10px', paddingTop: '5px' }}>
                    <Loading transform={1} height={17} width={40} color='darkGray' />
                </div>);
        }
        return(
            <Button
                color='info'
                onClick={onSubmit}
                className='downloadButton' >
                Save
            </Button>);
    }

    return (
        <ErrorComponent Children message='Error'>
            <Card chart style={{ overflow: 'visible', marginTop: '10px', marginBottom: '0' }} className='node-edit-card'>
            <CardHeader color='info' icon>
                <CardIcon color='info'>
                   <Notifications/>
                </CardIcon>
                <h3 style={{ ...style.cardTitle, textAlign: 'left' }}>{"Notifications"}</h3>
            </CardHeader>
            <CardBody>
            <form>
                <GridContainer style={{ margin: '0 0 0 -15px' }}>
                <GridItem xs={12} style={{ margin: '25px 0 0 0' }}>

                    <div
                        style={{
                            display: 'grid',
                            gridTemplateColumns: '1fr auto',
                            rowGap: '24px',
                            columnGap: '16px',
                            alignItems: 'center',
                            width: '80%'
                        }}
                    >
                        <InputLabel id="system-notif-email-label" style={{ position: 'static' }}> E-mail</InputLabel>
                        <Switch 
                            checked={emailOn} 
                            onChange={(e) => setEmailOn(!emailOn)} 
                            disabled={systemVersion == 'W2'}
                            inputProps={{
                                style: {
                                opacity: 0,
                                appearance: 'none',
                                WebkitAppearance: 'none',
                                MozAppearance: 'none'
                                }
                            }}
                        />

                        <InputLabel id="system-notif-push-label" style={{ position: 'static' }}>Push</InputLabel>
                        <Switch 
                            checked={pushOn} 
                            onChange={(e) => setPushOn(!pushOn)}
                        />

                        <InputLabel id="system-notif-sms-label" style={{ position: 'static' }}>SMS</InputLabel>
                        <Switch 
                            checked={smsOn} 
                            onChange={(e) => setSmsOn(!smsOn)} 
                            disabled={accountCategory !== 'wisene' || systemVersion == 'W2'}
                            inputProps={{
                                style: {
                                opacity: 0,
                                appearance: 'none',
                                WebkitAppearance: 'none',
                                MozAppearance: 'none'
                                }
                            }}
                        />
                    </div>

                </GridItem>
                <GridItem xs={12} style={{ margin: '25px 0 0 0' }}>
                    {button()}
                </GridItem>
                </GridContainer>
            </form>
            </CardBody>
        </Card>
    </ErrorComponent>
    );
}



const mapStateToProps = (state) => {
    return {
        settingNotificationsSuccess: state.dashboard.settingNotificationsSuccess,
        settingNotificationsFailed: state.dashboard.settingNotificationsFailed,
        moblieView: state.dashboard.mobileView
    }
}
const actions = { setSystemNotifications };
export const ExportCardWithStyles = dashboardStyle(SystemNotificationsCard);
export default connect(mapStateToProps, actions)(ExportCardWithStyles);
